// Public entrypoint for `@prerender/mcp-flags`. This file is the only
// surface external consumers should import from. Internally, helpers
// (`applyMcpFlagDelta.ts`, `validateMcpFlagSet.ts`) read the catalogue
// from `./catalogue` directly to avoid a circular dependency through
// this file.

export { MCP_FLAGS, MCP_FLAG_VALUES, MCP_FLAG_DEPENDENCIES, isMcpFlag, type McpFlag } from './catalogue';

export { applyMcpFlagDelta, formatMcpFlagFailures } from './applyMcpFlagDelta';

export type {
  McpFlagDeltaInput,
  McpFlagDeltaResult,
  McpFlagFailure,
  UnknownFlagFailure,
  MissingParentFailure,
  ConflictingFlagFailure,
  InvalidCurrentSetFailure,
} from './applyMcpFlagDelta';

export {
  validateMcpFlagSet,
  type ValidateMcpFlagSetResult,
  type ValidateMcpFlagSetFailure,
} from './validateMcpFlagSet';
